'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var SvgIcon = require('../../library/DataDisplay/SvgIcon.js');
var iconStyles = require('../iconStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var NavHQ = function NavHQ(props) {
  return React__default["default"].createElement(SvgIcon, _objectSpread({}, props, {
    viewBox: "0 0 24 24"
  }), React__default["default"].createElement("g", null, React__default["default"].createElement("polygon", {
    points: "13.1,9 14.1,9 14.1,3 6.1,3 6.1,8 1,8 1,21 2,21 2,9 7.1,9 7.1,4 13.1,4 \t\t"
  }), React__default["default"].createElement("rect", {
    x: "4.1",
    y: "11",
    width: "2",
    height: "2"
  }), React__default["default"].createElement("rect", {
    x: "9.1",
    y: "5",
    width: "2",
    height: "2"
  }), React__default["default"].createElement("rect", {
    x: "4.1",
    y: "15",
    width: "2",
    height: "2"
  }), React__default["default"].createElement("rect", {
    x: "4.1",
    y: "19",
    width: "2",
    height: "2"
  })), React__default["default"].createElement("path", {
    d: "M20.9,13.2h-2.1v-2.8H9c-0.8,0-1.4,0.6-1.4,1.4v7.8H9c0,1.2,0.9,2.1,2.1,2.1s2.1-0.9,2.1-2.1h4.2c0,1.2,0.9,2.1,2.1,2.1\n\t\t\t\tc1.2,0,2.1-0.9,2.1-2.1H23V16L20.9,13.2z M11.1,20.6c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1s1.1,0.5,1.1,1.1\n\t\t\t\tC12.1,20.1,11.7,20.6,11.1,20.6z M20.6,14.2L22,16h-3.1v-1.8H20.6z M19.5,20.6c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1\n\t\t\t\tc0.6,0,1.1,0.5,1.1,1.1C20.6,20.1,20.1,20.6,19.5,20.6z"
  }));
};

var NavHQ$1 = iconStyles()(NavHQ);

module.exports = NavHQ$1;
